import { StandardEvents } from '@shopify/events';

const badgeSelector = '[data-um-cart-count]';
let issuedUpdate = 0;
let appliedUpdate = 0;
let lastKnownCount = readCount(document.querySelector(badgeSelector)?.textContent);

function readCount(value) {
  if (value === null || value === undefined || value === '') return null;
  const count = Number(value);
  return Number.isSafeInteger(count) && count >= 0 ? count : null;
}

function sumQuantities(items) {
  if (!Array.isArray(items)) return null;
  let total = 0;
  for (const item of items) {
    const quantity = readCount(item?.quantity);
    if (quantity === null) return null;
    total += quantity;
  }
  return readCount(total);
}

function applyCount(count, updateNumber = appliedUpdate) {
  if (count === null || updateNumber < appliedUpdate) return;
  appliedUpdate = updateNumber;
  lastKnownCount = count;
  document.querySelectorAll(badgeSelector).forEach((badge) => {
    badge.textContent = String(count);
    badge.hidden = count === 0;
  });
  const label = count === 0 ? 'Carrello, vuoto' : count === 1 ? 'Carrello, 1 articolo' : 'Carrello, ' + count + ' articoli';
  document.querySelectorAll('[data-um-header-cart]').forEach((link) => link.setAttribute('aria-label', label));
}

function cartJsonUrl() {
  const localizedUrl = document.querySelector('[data-um-cart-json-url]')?.getAttribute('data-um-cart-json-url');
  if (localizedUrl) return localizedUrl;
  const localeRoot = window.Shopify?.routes?.root || '/';
  return localeRoot.replace(/\/?$/, '/') + 'cart.js';
}

async function handleCartUpdate(event) {
  const updateNumber = ++issuedUpdate;
  try {
    const hasPromise = event.promise && typeof event.promise.then === 'function';
    const settled = hasPromise ? await event.promise : { cart: event.cart, detail: event.detail };
    const detail = settled?.detail ?? event.detail;
    if (settled?.didError === true || detail?.didError === true) return;

    // StandardEvents resolves with the current SDK cart. The native header uses totalQuantity.
    let count = readCount(settled?.cart?.totalQuantity);
    if (count === null) count = readCount(event.cart?.totalQuantity);
    // itemCount can be the newly added quantity; only the full items array gives the cart total.
    if (count === null) count = sumQuantities(detail?.items);
    if (count !== null) {
      applyCount(count, updateNumber);
      return;
    }
    // Do not fetch during an unconfirmed/pending update.
    if (!hasPromise && detail?.didError !== false) return;
    const response = await fetch(cartJsonUrl(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart count request failed (' + response.status + ')');
    const cart = await response.json();
    count = readCount(cart?.item_count);
    if (count === null) count = sumQuantities(cart?.items);
    if (count !== null) applyCount(count, updateNumber);
  } catch (error) {
    // Keep the previous count and leave the native cart error handling untouched.
    if (error?.name !== 'AbortError') console.warn('[Urban Motion] Cart count could not be refreshed:', error);
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, handleCartUpdate);
document.addEventListener('shopify:section:load', () => applyCount(lastKnownCount));
applyCount(lastKnownCount);
